import type { MessageBundle } from '@amzn/arb-tools';
import { safeGetMessage } from '@xbcb/ui-utils';
import { HtsObject } from 'types';

export const getRowLabel = (
  index: number,
  isPrimary: boolean,
  bundle: MessageBundle,
  htsObj?: HtsObject,
): string => {
  if (isPrimary) {
    return htsObj?.text
      ? safeGetMessage(
          bundle,
          'primary_hts_label_with_text',
          { text: htsObj.text },
          `Primary HTS - ${htsObj.text}`,
        )
      : safeGetMessage(bundle, 'primary_hts_label', undefined, 'Primary HTS');
  }
  if (htsObj?.additionalTariffType) {
    return safeGetMessage(
      bundle,
      `tariff_type_${htsObj.additionalTariffType}`,
      undefined,
      htsObj.additionalTariffType,
    );
  }
  if (htsObj?.text) {
    const text =
      htsObj.text.length > 30 ? `${htsObj.text.slice(0, 30)}...` : htsObj.text;
    return safeGetMessage(
      bundle,
      'additional_hts_label_with_text',
      { text },
      `Additional HTS - ${text}`,
    );
  }
  return safeGetMessage(
    bundle,
    'additional_hts_label',
    { index: index + 1 },
    `Additional HTS #${index + 1}`,
  );
};

export const formatDutyRate = (htsObj?: HtsObject): string | undefined => {
  if (!htsObj?.rate) return undefined;
  const { adValorem, specific } = htsObj.rate;
  if (adValorem != null) return `${parseFloat((adValorem * 100).toFixed(2))}%`;
  if (specific != null) return `${specific}`;
  return undefined;
};

export const computeDutyValue = (
  htsObj: HtsObject | undefined,
  totalValue: number,
): string | undefined => {
  if (!htsObj?.rate) return undefined;
  const { adValorem, specific } = htsObj.rate;
  if (adValorem != null) return `$${(totalValue * adValorem).toFixed(2)}`;
  if (specific != null) return `$${(totalValue * specific).toFixed(2)}`;
  return undefined;
};
